import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

interface Option {
  value: server.dto.FormElementBehaviors;
  label: string;
}

const options: Option[] = [{
  value: "notVisible",
  label: RESX.Webform.FormElementIsHidden,
}, {
  value: "visibleOptional",
  label: RESX.Webform.FormElementIsVisibleInputOptional,
}, {
  value: "visibleMandatory",
  label: RESX.Webform.FormElementIsVisibleInputRequired,
}]

const getFormElementBehaviourOption = (value: server.dto.FormElementBehaviors): Option | undefined => {
  return options.find(o => o.value === value);
}

export const getFormElementBehaviourLabel = (value: server.dto.FormElementBehaviors): string => {
  return getFormElementBehaviourOption(value)?.label || "";
}

const FormElementBehaviourDropdown = (props: DropdownProps<server.dto.FormElementBehaviors>) => {
  const selectedOption = getFormElementBehaviourOption(props.value);

  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={options}
    getLabel={v => v.label}
    getValue={(v) => v.value}
    value={selectedOption}
    onChange={(v) => props.onChange(v.value)}
    config={props.config}
  />;
};

export default FormElementBehaviourDropdown;